import React from 'react';
import { Modal } from './Modal';
import { Button } from './Button';

type Tone = 'danger' | 'brand' | 'warning';

export interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message?: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  tone?: Tone;
  loading?: boolean;
}

const confirmVariant: Record<Tone, 'danger' | 'primary' | 'success'> = {
  danger: 'danger',
  brand: 'primary',
  warning: 'primary',
};

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  tone = 'danger',
  loading,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={title}
    size="sm"
    data-testid="confirm-dialog"
    footer={
      <>
        <Button variant="ghost" onClick={onClose} disabled={loading}>
          {cancelText}
        </Button>
        <Button variant={confirmVariant[tone]} onClick={onConfirm} loading={loading} data-testid="confirm-dialog-confirm">
          {confirmText}
        </Button>
      </>
    }
  >
    {typeof message === 'string' ? <p className="text-base text-foreground-muted">{message}</p> : message}
  </Modal>
);
